import {style} from 'typestyle'
import * as csstips from 'csstips'

export const CategoryMenuItem = style({
    // boxShadow: '0 3px 12px 0 #F0F0F0'
})

export const slideMenu = style({
    ...csstips.flexRoot,
    overflow: 'auto'
})

export const slideMenuIfPc = style({
    ...csstips.flexRoot,
    'overflowX': 'scroll',
    'overflowY': 'hidden',
    '-webkit-overflow-scrolling': 'touch',
    '$nest': {
        '&::-webkit-scrollbar': {
            width: 6,
            height: 6
        },
        /*定义滚动条的轨道，内阴影及圆角*/
        '&::-webkit-scrollbar-track': {
            borderRadius: 10,
            backgroundColor: 'rgba(195, 195, 195, 0.12156862745098039)'
        },
        /*定义滑块，内阴影及圆角*/
        '&::-webkit-scrollbar-thumb': {
            /*width: 10px;*/
            height: 20,
            borderRadius: 10,
            backgroundColor: 'rgba(152, 152, 152, 0.7019607843137254)'
        }
    }
})

export const slideMenuItem = style({
      fontSize: '14px',
      color: '#666666',
      padding: '5px 16px 5px 16px',
      background: '#F4F4F4',
      borderRadius: '50px',
      marginLeft: 15,
      ...csstips.flexRoot,
      ...csstips.centerCenter,
      whiteSpace: 'nowrap',
      ...csstips.flexRoot,
      ...csstips.center,
      $nest: {
          '&:active': {
              background: '#cccccc'
          },
          '&:first-child': {
              marginLeft: 15
          }
      }
})

export const seletctActive = style({
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '18px',
    background: '#FFEEEA',
    color: '#FF5A31',
    $nest: {
        // '&::after': {
        //     content: `" "`,
        //     position: 'absolute',
        //     height: 3,
        //     width: 20,
        //     backgroundColor: '#FF5A31',
        //     borderRadius: 1.5,
        //     bottom: 0,
        //     left: '50%',
        //     transform: 'translateX(-50%)'
        // },
        '&:active': {
            background: '#FFEEEA'
        }
    }
})

export const categoryMenuFixed = style({
     position: 'fixed',
     top: 48,
     paddingTop: 6,
     background: '#fff',
     zIndex: 10,
     width: '100%',
     maxWidth: 480,
     paddingBottom: 10,
    //  boxShadow: '0 3px 12px 0 #F0F0F0',
     $nest: {
         '&::after': {
            content: `""`,
            boxShadow: '0 4px 4px 0 #F0F0F0',
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            height: 5
         }
     }
})



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryMenuItem/CategoryMenuItem.style.ts